import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClientService } from 'src/app/base/services/client/client.service';
import { ClientAutocompleteComponent } from 'src/app/base/shared/client-autocomplete/client-autocomplete.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { TagMasterService } from './tag-master.service';
import { DataManager } from '@syncfusion/ej2-data';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { GridModule, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { DatePipe, NgIf } from '@angular/common';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ModalService } from 'src/app/base/shared/modal/modal.service';

@Component({
    selector: 'app-tag-master',
    templateUrl: './tag-master.component.html',
    styleUrls: ['./tag-master.component.scss'],
    imports: [
        TitleBarComponent,
        ClientAutocompleteComponent,
        GridModule,
        NgIf,
        TranslateModule,
        ToolbarModule,
        DatePipe
    ]
})

export class TagMasterComponent extends GridBaseComponent implements OnInit {

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();

  constructor(clientService: ClientService,
    translate: TranslateService,
    private tagMasterService: TagMasterService,
    private spinnerService: SpinnerService,
    private modalService: ModalService,
  ) {
    super(clientService, translate, tagMasterService);
    this.gridCommands = [this.gridCommands.find((command) => command.type === SfCommandButtonType.Delete)];
    this.editSettings = GridConstantsFactory.createStandardEditSettings();
    this.editSettings.allowEditing = false;
    this.editSettings.allowAdding = false;
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.tagMasterService, this.spinnerService),
    });
  }

  public override get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public override set selectedClient(value: ClientDTO) {
    this.clientService.selectedClient = value;
    this.onClientSelected(value);
  }

  public onMultipleDelete() {
    // get the primary key of the selected rows
    const selectedRecords = this.grid.getSelectedRecords();
    const selectedIds = selectedRecords.map((record) => record['id']);
    if (selectedIds.length > 0) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.tag-master.messages.delete-title', 'i18n.domain.tag-master.messages.delete-multiple-question');
      dialog.onOkSubject.subscribe(() => {
        this.tagMasterService.deleteRecords(selectedIds).subscribe(() => {
          this.grid.refresh();
        });
      });
    }
  }

  public rowDataBound(args: RowDataBoundEventArgs) {
    // if record is active then hide the row selection checkbox and delete button
    if (args.data['isActive']) {
      args.isSelectable = false;
      var button = args.row.getElementsByClassName('icon-trash-can');
      if (button && button.length > 0 && button[0].parentElement) {
        button[0].parentElement.hidden = true;
      }
      var checkBox = args.row.getElementsByClassName('e-checkselect');
      if (checkBox && checkBox.length > 0 && checkBox[0].parentElement) {
        checkBox[0].parentElement.hidden = true;
      }
    }
  }

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }
}
